import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { GlobalMouseMoveMonitor, standardMouseMoveMerger } from '../../globalMouseMoveMonitor.js';
import { Widget } from '../widget.js';
import { IntervalTimer, TimeoutTimer } from '../../../common/async.js';
import { addClasses } from '../../dom.js';
/**
 * The arrow image size.
 */

export var ARROW_IMG_SIZE = 11;
export var ScrollbarArrow = /*#__PURE__*/function (_Widget) {
  _inherits(ScrollbarArrow, _Widget);

  var _super = _createSuper(ScrollbarArrow);

  function ScrollbarArrow(opts) {
    var _this;

    _classCallCheck(this, ScrollbarArrow);

    _this = _super.call(this);
    _this._onActivate = opts.onActivate;
    _this.bgDomNode = document.createElement('div');
    _this.bgDomNode.className = 'arrow-background';
    _this.bgDomNode.style.position = 'absolute';
    _this.bgDomNode.style.width = opts.bgWidth + 'px';
    _this.bgDomNode.style.height = opts.bgHeight + 'px';

    if (typeof opts.top !== 'undefined') {
      _this.bgDomNode.style.top = '0px';
    }

    if (typeof opts.left !== 'undefined') {
      _this.bgDomNode.style.left = '0px';
    }

    if (typeof opts.bottom !== 'undefined') {
      _this.bgDomNode.style.bottom = '0px';
    }

    if (typeof opts.right !== 'undefined') {
      _this.bgDomNode.style.right = '0px';
    }

    _this.domNode = document.createElement('div');
    _this.domNode.className = opts.className;
    addClasses(_this.domNode, opts.icon.classNames);
    _this.domNode.style.position = 'absolute';
    _this.domNode.style.width = ARROW_IMG_SIZE + 'px';
    _this.domNode.style.height = ARROW_IMG_SIZE + 'px';

    if (typeof opts.top !== 'undefined') {
      _this.domNode.style.top = opts.top + 'px';
    }

    if (typeof opts.left !== 'undefined') {
      _this.domNode.style.left = opts.left + 'px';
    }

    if (typeof opts.bottom !== 'undefined') {
      _this.domNode.style.bottom = opts.bottom + 'px';
    }

    if (typeof opts.right !== 'undefined') {
      _this.domNode.style.right = opts.right + 'px';
    }

    _this._mouseMoveMonitor = _this._register(new GlobalMouseMoveMonitor());

    _this.onmousedown(_this.bgDomNode, function (e) {
      return _this._arrowMouseDown(e);
    });

    _this.onmousedown(_this.domNode, function (e) {
      return _this._arrowMouseDown(e);
    });

    _this._mousedownRepeatTimer = _this._register(new IntervalTimer());
    _this._mousedownScheduleRepeatTimer = _this._register(new TimeoutTimer());
    return _this;
  }

  _createClass(ScrollbarArrow, [{
    key: "_arrowMouseDown",
    value: function _arrowMouseDown(e) {
      var _this2 = this;

      var scheduleRepeater = function scheduleRepeater() {
        _this2._mousedownRepeatTimer.cancelAndSet(function () {
          return _this2._onActivate();
        }, 1000 / 24);
      };

      this._onActivate();

      this._mousedownRepeatTimer.cancel();

      this._mousedownScheduleRepeatTimer.cancelAndSet(scheduleRepeater, 200);

      this._mouseMoveMonitor.startMonitoring(e.target, e.buttons, standardMouseMoveMerger, function (mouseMoveData) {
        /* Intentional empty */
      }, function () {
        _this2._mousedownRepeatTimer.cancel();

        _this2._mousedownScheduleRepeatTimer.cancel();
      });

      e.preventDefault();
    }
  }]);

  return ScrollbarArrow;
}(Widget);